import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { CalService } from '../../../core/service/msal-auth.service';
import OktaAuth, { SigninWithCredentialsOptions, TokenResponse, Tokens } from '@okta/okta-auth-js';
import { EMDMICONS } from '../../constants/icon-packs.constant';
import { OktaAuthService } from '../../../core/service/okta-auth.service';
import { environment } from '../../../../environments/environment';
import OktaSignIn from '@okta/okta-signin-widget';
import { OKTA_AUTH } from '@okta/okta-angular';
import { Observable } from 'rxjs';
import { UserLoginService } from '../../service/user-login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  signIn: any;
  isLoadingResults = true;
  userName: string = "";
  userNameError: boolean = false;
  iconPacks = EMDMICONS;
  isUserKeptSignIn: boolean = false;
  userResponseSubject: any;
  environment:any = environment;
  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    // private calService: CalService,
    private oktaAuthService: OktaAuthService,
    private router: Router,
    private userService: UserLoginService,
    private userLoginService: UserLoginService,
    private route: ActivatedRoute ) {
      // Store the intended route from query parameters or current URL
  //this.storeIntendedRoute();

    this.signIn = new OktaSignIn({
      baseUrl: environment.oidc.issuer.split('/oauth2')[0],
      clientId: environment.oidc.clientId,
      redirectUri: environment.oidc.redirectUri,
      issuer: environment.oidc.issuer,
      authParams: {
        pkce: true,
        responseType: 'code',
        issuer: environment.oidc.issuer,
      },
      logo: 'https://cdn-nextpage.chevron.com/img/favicon.gif',
      i18n: {
        en: {
          'primaryauth.title': 'CSMRT',
        },
      },
      useClassicEngine: false,
    });

    // Add event listener to set checkbox default after widget renders
    this.signIn.on('ready', () => {
      setTimeout(() => {
        const rememberMeCheckbox = document.querySelector('input[name="rememberMe"]') as HTMLInputElement;
        if (rememberMeCheckbox) {
          rememberMeCheckbox.checked = true;
        }
      }, 100);
    });
    if ("isUserKeptSignIn" in localStorage) {
      this.isUserKeptSignIn = localStorage.getItem("isUserKeptSignIn") === "true";
      if (this.isUserKeptSignIn && "userNameForSignIn" in localStorage) {
        this.userName = localStorage.getItem("userNameForSignIn") ?? "";
      }
    }
  }
  private storeIntendedRoute(): void {
  // Check if there's a returnUrl query parameter
  const returnUrl = this.route.snapshot.queryParams['email'];
  
  
  if (returnUrl) {
    sessionStorage.setItem('intendedRoute', returnUrl);
  } else {
    // Get the original URI that was attempted before redirect to login
    const originalUri = this.oktaAuth.getOriginalUri();
    if (originalUri && originalUri !== window.location.origin && !originalUri.includes('/login')) {
      sessionStorage.setItem('intendedRoute', originalUri);
    }
  }
}
  ngOnInit() {
    //sessionStorage.clear(); // to clear the session storage everytime the login page is loaded
    //localStorage.clear();
    //localStorage.removeItem("CSMRTUserLastLoggedIn");
    
    const originalUri = this.oktaAuth.getOriginalUri();
    if (!originalUri || originalUri === window.location.origin) {
      this.oktaAuth.setOriginalUri('/Home');
    }

    this.oktaAuth.token.getWithoutPrompt({
      responseType: ['id_token', 'token'],
      redirectUri: environment.oidc.redirectUri,
      issuer: environment.oidc.issuer
    }).then((tokens: TokenResponse) => {      
      this.signIn.remove();
      this.oktaAuth.handleLoginRedirect(tokens.tokens);
      //  this.oktaAuth.tokenManager.setTokens(tokens.tokens);

    }).catch((err: any) => {

      this.signIn.showSignInToGetTokens({
        el: '#sign-in-widget',
        scopes: environment.oidc.scopes
      }).then((tokens: Tokens) => {
        this.signIn.remove();
        this.oktaAuth.handleLoginRedirect(tokens);        
      }).catch((err: any) => {
        throw err;
      });
      this.isLoadingResults = false;
    });
  }

  ngOnDestroy() {
    this.signIn.remove();
  }

  onkeepMeSignInCheckboxChange(event: any) {
    if (!event) {
      localStorage.removeItem("isUserKeptSignIn");
      localStorage.removeItem("userNameForSignIn");
    } else {
      localStorage.setItem("isUserKeptSignIn", "true");
    }
  }

  useInfoCapture() {
    if (this.isUserKeptSignIn) {
      localStorage.setItem("isUserKeptSignIn", "true");
      localStorage.setItem("userNameForSignIn", this.userName);
    }
  }

  async oktaLogin(): Promise<void> {
    this.useInfoCapture();
    await this.oktaAuthService.login();
  }

  async oktaLoginWithCredentials(): Promise<void> {
    this.useInfoCapture();
    if (this.userName !== '') {
      this.userNameError = false;
      let credentials: SigninWithCredentialsOptions = {
        username: this.userName,
        password: ""
      };
      this.oktaAuthService.loginWithCredentials(credentials);
    } else {
      this.userNameError = true;
    }
  }

  async calLogin() {
    // await this.calService.signIn();
    await this.oktaAuthService.logout();
  }
}
